"use strict";

var _classCallCheck = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/builds/Ayh8cDzT/0/mcfe/misrc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ReactDOM = require("react-dom");

var matchQueries_1 = require("container-query-toolkit/lib/matchQueries");

var ContainerQueryCore_1 = require("./ContainerQueryCore");

var isShallowEqual_1 = require("./isShallowEqual");
/**
 * <ContainerQuery query={query} initialSize={{width: 123, height: 456}}>
 *   {(params) => {
 *     <div className={classname(params)}></div>
 *   }}
 * </ContainerQuery>
 */


var ContainerQuery = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerQuery, _React$Component);

  var _super = _createSuper(ContainerQuery);

  function ContainerQuery(props) {
    var _this;

    _classCallCheck(this, ContainerQuery);

    _this = _super.call(this, props);
    _this.cqCore = null;
    _this.state = {
      params: props.initialSize ? matchQueries_1.default(props.query)(props.initialSize) : {},
      props: props,
      cqCore: _this.cqCore,
      _startObserving: _this._startObserving
    };
    return _this;
  }

  _createClass(ContainerQuery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._startObserving(this.props.query);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.cqCore.observe(ReactDOM.findDOMNode(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cqCore.disconnect();
      this.cqCore = null;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.state.params);
    }
  }, {
    key: "_startObserving",
    value: function _startObserving(query) {
      var _this2 = this;

      this.cqCore = new ContainerQueryCore_1.default(query, function (params) {
        _this2.setState({
          params: params
        });
      });
      this.cqCore.observe(ReactDOM.findDOMNode(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // componentWillReceiveProps and componentDidMount can potentially run out of order,
      // so we need to consider the case where cqCore is not initialized yet.
      if (prevState.cqCore && !isQueriesEqual(prevState.props.query, nextProps.query)) {
        prevState.cqCore.disconnect();
        prevState.cqCore = null;

        prevState._startObserving(nextProps.query);
      }

      return null;
    }
  }]);

  return ContainerQuery;
}(React.Component);

exports.ContainerQuery = ContainerQuery;

function applyContainerQuery(Component, query, initialSize) {
  var _a;

  return _a = /*#__PURE__*/function (_React$Component2) {
    _inherits(ContainerQuery, _React$Component2);

    var _super2 = _createSuper(ContainerQuery);

    function ContainerQuery(props) {
      var _this3;

      _classCallCheck(this, ContainerQuery);

      _this3 = _super2.call(this, props);
      _this3.cqCore = null;
      _this3.state = {
        params: initialSize ? matchQueries_1.default(query)(initialSize) : {},
        props: props,
        cqCore: _this3.cqCore,
        _startObserving: _this3._startObserving
      };
      return _this3;
    }

    _createClass(ContainerQuery, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this4 = this;

        this.cqCore = new ContainerQueryCore_1.default(query, function (params) {
          _this4.setState({
            params: params
          });
        });
        this.cqCore.observe(ReactDOM.findDOMNode(this));
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.cqCore.observe(ReactDOM.findDOMNode(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.cqCore.disconnect();
        this.cqCore = null;
      }
    }, {
      key: "_startObserving",
      value: function _startObserving(query) {
        var _this5 = this;

        this.cqCore = new ContainerQueryCore_1.default(query, function (params) {
          _this5.setState({
            params: params
          });
        });
        this.cqCore.observe(ReactDOM.findDOMNode(this));
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, Object.assign({}, this.props, {
          containerQuery: this.state.params
        }));
      }
    }]);

    return ContainerQuery;
  }(React.Component), _a.displayName = Component.displayName ? "ContainerQuery(".concat(Component.displayName, ")") : 'ContainerQuery', _a;
}

exports.applyContainerQuery = applyContainerQuery;
var hasOwnProperty = Object.prototype.hasOwnProperty;

function isQueriesEqual(queryA, queryB) {
  var keysA = Object.keys(queryA);
  var keysB = Object.keys(queryB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(queryB, keysA[i]) || !isShallowEqual_1.default(queryA[keysA[i]], queryB[keysA[i]])) {
      return false;
    }
  }

  return true;
}